@if (totalShares || totalNomineeShares || (businessesList && businessesList.length > 0)) {
  <div [class.is-loading]="isLoading">
    <div class="tw-mb-10 tw-max-w-6xl">
      <div class="tw-grid tw-grid-cols-1 tw-items-stretch tw-gap-5 sm:tw-grid-cols-4">
        <div
          class="tw-flex tw-flex-col tw-justify-center tw-rounded tw-border tw-border-divider tw-bg-white tw-p-5"
        >
          <div class="p-skeleton-bar tw-mb-2.5 !tw-block tw-text-lg">
            {{ 'offerCreation.totalShares' | translate }}
          </div>
          <div class="p-skeleton-bar tw-text-2xl tw-font-medium tw-text-black">
            {{ totalShares | number }}
          </div>
        </div>
        <div
          class="tw-flex tw-flex-col tw-justify-center tw-rounded tw-border tw-border-divider tw-bg-white tw-p-5"
        >
          <div class="p-skeleton-bar tw-mb-2.5 !tw-block tw-text-lg">
            {{ 'offerCreation.totalNomineeShares' | translate }}
          </div>
          <div class="p-skeleton-bar tw-text-2xl tw-font-medium tw-text-black">
            {{ totalNomineeShares | number }}
          </div>
          <small class="p-skeleton-hidden">
            ({{ nomineeSharesPercentage | number }}% of Total Shares)
          </small>
        </div>
        <div
          class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded tw-border tw-border-divider tw-bg-white tw-p-6 sm:tw-col-span-2"
        >
          <div class="pitchin-icon pitchin-icon-upload tw-mb-4 tw-text-3xl tw-text-primary"></div>
          <div class="tw-w-full tw-max-w-md">
            <button
              (click)="openUploadAnnouncementModal()"
              class="tw-mb-2 tw-flex tw-w-full tw-items-center tw-justify-center tw-rounded tw-border tw-border-primary tw-px-4 tw-py-2 tw-text-primary tw-transition-colors hover:tw-bg-primary/5"
            >
              {{ 'raise.postNewAnnouncement' | translate }}
            </button>
            <button
              (click)="openUploadModal()"
              class="tw-flex tw-w-full tw-items-center tw-justify-center tw-rounded tw-border tw-border-primary tw-px-4 tw-py-2 tw-text-primary tw-transition-colors hover:tw-bg-primary/5"
            >
              Upload General Documents
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<div class="tw-mb-5 tw-text-xl tw-font-bold tw-text-black">
  {{ 'raise.marketInformation' | translate }}
</div>

@if (businessesList) {
  <div class="mysec-mobile-table mobile-view row tw-mb-8 tw-rounded">
    <div class="col-12">
      <table class="tw-w-full">
        <thead>
          <th class="tw-text-xs tw-font-medium">{{ 'mysec.businesses' | translate }}</th>
        </thead>
        <tbody>
          @for (item of businessesList; track item) {
            <tr>
              <td>
                @if (
                  item?.tickerCode &&
                  ![ShareMarketStatus.Dehosting, ShareMarketStatus.Inactive].includes(item?.status)
                ) {
                  <a
                    class="text-unset tw-flex tw-items-start"
                    [routerLink]="['/pstx', item.tickerCode]"
                  >
                    <ng-container
                      *ngTemplateOutlet="mobileRow; context: { item: item }"
                    ></ng-container>
                  </a>
                } @else {
                  <ng-container
                    *ngTemplateOutlet="mobileRow; context: { item: item }"
                  ></ng-container>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}

@if (businessesList) {
  <div class="row tw-mb-8">
    <div class="col-12">
      <div class="p-table__wrapper">
        <div class="p-table__body">
          <mat-table class="responsive-table p-table" [dataSource]="businessesList">
            <ng-container matColumnDef="Code">
              <mat-header-cell *matHeaderCellDef>
                {{ 'Counter' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let item" class="tw-flex-col tw-items-start">
                @if (
                  item?.tickerCode &&
                  ![ShareMarketStatus.Dehosting, ShareMarketStatus.Inactive].includes(item?.status)
                ) {
                  <a
                    [routerLink]="['/pstx', item.tickerCode]"
                    class="p-link-underline p-link-primary p-skeleton-bar tw-uppercase"
                    >{{ item.tickerCode }}</a
                  >
                } @else {
                  <div class="p-skeleton-bar tw-uppercase">{{ item.tickerCode }}</div>
                }
                <div
                  class="p-skeleton-hidden tw-text-sm tw-font-medium tw-text-body/50"
                  [class.!tw-text-status-success]="item.status === ShareMarketStatus.Active"
                  [class.!tw-text-status-fail]="item.status === ShareMarketStatus.Inactive"
                >
                  {{ ShareMarketStatus[item.status] }}
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="DirectShare">
              <mat-header-cell *matHeaderCellDef>
                {{ 'mysec.directShare' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let item" class="tw-flex-col tw-items-start">
                @if (item.shareHolder?.directShares !== 0) {
                  <div class="p-skeleton-bar">
                    {{ item.shareHolder?.directShares | number }}
                    {{
                      'raise.share_plural' | translate: { 'count': item.shareHolder?.directShares }
                    }}
                  </div>
                } @else {
                  <span class="p-skeleton-bar">-</span>
                }
                @if (item.shareHolder?.directShareHolders !== 0) {
                  <div class="p-skeleton-hidden">
                    ({{ item.shareHolder?.directShareHolders | number }}
                    {{
                      'raise.shareholder_plural'
                        | translate: { 'count': item.shareHolder?.directShareHolders }
                    }})
                  </div>
                }
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="NomineeShare">
              <mat-header-cell *matHeaderCellDef>
                {{ 'mysec.nomineeShare' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let item" class="tw-flex-col tw-items-start">
                @if (item.shareHolder?.nomineeShares !== 0) {
                  <div class="p-skeleton-bar">
                    {{ item.shareHolder?.nomineeShares | number }}
                    {{
                      'raise.share_plural' | translate: { 'count': item.shareHolder?.nomineeShares }
                    }}
                  </div>
                } @else {
                  <span class="p-skeleton-bar">-</span>
                }
                @if (item.shareHolder?.nomineeShareHolders !== 0) {
                  <div class="p-skeleton-hidden">
                    ({{ item.shareHolder?.nomineeShareHolders | number }}
                    {{
                      'raise.shareholder_plural'
                        | translate: { 'count': item.shareHolder?.nomineeShareHolders }
                    }})
                  </div>
                }
              </mat-cell>
            </ng-container>
            <!-- <ng-container matColumnDef="Status">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell *matCellDef="let item">
                <ng-container
                *ngTemplateOutlet="status; context: {item:item, class: 'tw-justify-start', childClass: 'last:tw-mr-0'}"></ng-container>
              </mat-cell>
            </ng-container> -->
            <ng-container matColumnDef="LastTrade">
              <mat-header-cell *matHeaderCellDef>
                {{ 'mysec.lastTrade' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                <div class="p-skeleton-bar">
                  {{
                    item.lastTrade
                      ? (item.lastTrade | numberSuffix: { numberFormat: '1.2-2' })
                      : '-'
                  }}
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="BestBid">
              <mat-header-cell *matHeaderCellDef>
                <div class="tw-flex tw-items-center">
                  <div class="tw-mr-1">{{ 'mysec.bestBid' | translate }}</div>
                  <div
                    class="pitchin-icon pitchin-icon-help-circle p-help-icon"
                    #tooltip="matTooltip"
                    matTooltip="{{
                      'The highest price that a buyer is currently willing to pay for a particular share'
                        | translate
                    }}"
                  ></div>
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                <div class="p-skeleton-bar">
                  {{
                    item.bestBid ? (item.bestBid | numberSuffix: { numberFormat: '1.2-2' }) : '-'
                  }}
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="BestAsk">
              <mat-header-cell *matHeaderCellDef>
                <div class="tw-flex tw-items-center">
                  <div class="tw-mr-1">{{ 'mysec.bestAsk' | translate }}</div>
                  <div
                    class="pitchin-icon pitchin-icon-help-circle p-help-icon"
                    #tooltip="matTooltip"
                    matTooltip="{{
                      'The lowest price at which a seller is currently willing to sell a particular share'
                        | translate
                    }}"
                  ></div>
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                <div class="p-skeleton-bar">
                  {{
                    item.bestOffer
                      ? (item.bestOffer | numberSuffix: { numberFormat: '1.2-2' })
                      : '-'
                  }}
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="OrderQty">
              <mat-header-cell *matHeaderCellDef>
                <div class="tw-flex tw-items-center">
                  <div class="tw-mr-1">{{ 'mysec.orderQty' | translate }}</div>
                  <div
                    class="pitchin-icon pitchin-icon-help-circle p-help-icon"
                    #tooltip="matTooltip"
                    matTooltip="{{ 'Total number of shares available for trade' | translate }}"
                  ></div>
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                <div class="p-skeleton-bar">
                  {{ item.orderQuantity ? (item.orderQuantity | number) : '-' }}
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="PriceChg">
              <mat-header-cell *matHeaderCellDef>
                <div class="d-flex align-items-center">
                  <div class="mr-1">{{ 'mysec.priceChg' | translate }}</div>
                  <div
                    class="pitchin-icon pitchin-icon-help-circle p-help-icon"
                    #tooltip="matTooltip"
                    matTooltip="{{ 'mysec.changePercentDescription' | translate }}"
                  ></div>
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                <ng-container
                  *ngTemplateOutlet="chgPrice; context: { item: item, class: 'tw-justify-start' }"
                ></ng-container>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayColumns"> </mat-header-row>
            <mat-row *matRowDef="let item; columns: displayColumns"> </mat-row>
          </mat-table>
          @if (!businessesList || businessesList.length == 0) {
            <div class="tw-w-full tw-py-4 tw-text-center">
              {{ 'common.noRecord' | translate }}
            </div>
          }
          @if (total > params.take) {
            <div class="p-table__footer">
              <div class="p-table__pagination p-skeleton-pagination">
                <ngb-pagination
                  [collectionSize]="total"
                  [(pageSize)]="params.take"
                  [(page)]="params.currentPage"
                  (pageChange)="changePage($event)"
                  [maxSize]="5"
                  [rotate]="true"
                >
                  <ng-template ngbPaginationPrevious>
                    <span class="p-table__pagination-icon">←</span>
                    <div class="p-table__pagination-label tw-pl-2">
                      {{ 'common.prev' | translate }}
                    </div>
                  </ng-template>
                  <ng-template class="page-no" ngbPaginationNumber let-page>
                    <div class="page-no">{{ page }}</div>
                  </ng-template>
                  <ng-template ngbPaginationNext>
                    <div class="p-table__pagination-label tw-pr-2">
                      {{ 'common.next' | translate }}
                    </div>
                    <span class="p-table__pagination-icon">→</span>
                  </ng-template>
                </ngb-pagination>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}

<div class="tw-mb-5 tw-mt-10 tw-text-xl tw-font-bold tw-text-black">Announcements</div>

<div class="row tw-mb-8">
  <div class="col-12">
    <div class="p-table__wrapper">
      <div class="p-table__body">
        <mat-table class="responsive-table p-table" [dataSource]="announcementsList">
          <ng-container matColumnDef="Title">
            <mat-header-cell *matHeaderCellDef>{{
              'raise.announcementTitle' | translate
            }}</mat-header-cell>
            <mat-cell *matCellDef="let item" class="tw-font-semibold tw-text-black">
              {{ item.title }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Audience">
            <mat-header-cell *matHeaderCellDef>{{ 'raise.audience' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let item" class="tw-text-body/60">
              {{ getAudienceLabel(item.audience) }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="PostDate">
            <mat-header-cell *matHeaderCellDef>{{ 'raise.postDate' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let item" class="tw-text-body/60">
              {{ item.publishedAt | date: 'dd MMM yyyy' }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Status">
            <mat-header-cell *matHeaderCellDef>{{ 'common.status' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <span
                [class]="getStatusClass(item.isPublished ? 2 : 1)"
                class="tw-rounded-full tw-px-3 tw-py-1 tw-text-xs tw-font-medium"
              >
                {{ getStatusLabel(item.isPublished ? 2 : 1) }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef>{{ 'common.actions' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <button
                (click)="viewAnnouncement(item)"
                class="tw-cursor-pointer tw-border-none tw-bg-transparent tw-font-medium tw-text-primary hover:tw-underline"
              >
                {{ 'common.view' | translate }}
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row
            *matHeaderRowDef="['Title', 'Audience', 'PostDate', 'Status', 'Actions']"
          ></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: ['Title', 'Audience', 'PostDate', 'Status', 'Actions']"
          ></mat-row>
        </mat-table>
        @if (announcementsList && announcementsList.length > 0) {
          <div class="tw-mt-4 tw-flex tw-justify-end tw-bg-white">
            <mat-paginator
              [length]="announcementTotal || 0"
              [pageIndex]="announcementParams.currentPage - 1"
              [pageSize]="announcementParams.take"
              [pageSizeOptions]="[5, 10, 20]"
              (page)="onAnnouncementPageChange($event)"
              aria-label="{{ 'common.selectPage' | translate }}"
            >
            </mat-paginator>
          </div>
        }

        @if (!announcementsList || announcementsList?.length === 0) {
          <div class="tw-w-full tw-border-t tw-bg-white tw-py-8 tw-text-center">
            {{ 'common.noRecord' | translate }}
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div class="tw-mb-5 tw-mt-10 tw-text-xl tw-font-bold tw-text-black">General Documents</div>

<div class="row tw-mb-8">
  <div class="col-12">
    <div class="p-table__wrapper">
      <div class="p-table__body">
        <mat-table class="responsive-table p-table" [dataSource]="pagedDocuments">
          <ng-container matColumnDef="DocName">
            <mat-header-cell *matHeaderCellDef>Document Name</mat-header-cell>
            <mat-cell *matCellDef="let doc" class="tw-font-semibold tw-text-black">
              <div class="tw-flex tw-items-center">
                <i class="pitchin-icon pitchin-icon-file-text tw-mr-2 tw-text-body/40"></i>
                {{ doc.attachmentName }}
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Audience">
            <mat-header-cell *matHeaderCellDef>Audience</mat-header-cell>
            <mat-cell *matCellDef="let doc" class="tw-text-body/60">
              {{ getAudienceLabel(doc.audience) }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="UploadDate">
            <mat-header-cell *matHeaderCellDef>Upload Date</mat-header-cell>
            <mat-cell *matCellDef="let doc" class="tw-text-body/60">
              {{ doc.createdAt?.startsWith('0001') ? '-' : (doc.createdAt | date: 'dd MMM yyyy') }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Status">
            <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
            <mat-cell *matCellDef="let doc">
              <span
                class="tw-rounded-full tw-px-3 tw-py-1 tw-text-xs tw-font-medium"
                [ngClass]="getStatusClass(doc.status)"
              >
                {{ getStatusLabel(doc.status) }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
            <mat-cell *matCellDef="let doc" class="tw-flex tw-gap-2">
              <button
                (click)="viewDocument(doc)"
                class="tw-font-medium tw-text-primary hover:tw-underline"
              >
                View
              </button>

              @if (doc.status === 1) {
                <span class="tw-text-gray-300">|</span>
                <button
                  (click)="deleteDocument(doc)"
                  class="tw-font-medium tw-text-status-fail hover:tw-underline"
                >
                  Delete
                </button>
              }
            </mat-cell>
          </ng-container>
          <mat-header-row
            *matHeaderRowDef="['DocName', 'Audience', 'UploadDate', 'Status', 'Actions']"
          ></mat-header-row>
          <mat-row
            *matRowDef="
              let row;
              columns: ['DocName', 'Audience', 'UploadDate', 'Status', 'Actions']
            "
          ></mat-row>
        </mat-table>

        @if (documentsList && documentsList.length > 0) {
          <div class="tw-mt-4 tw-flex tw-justify-end tw-bg-white">
            <mat-paginator
              [length]="documentsList.length"
              [pageSize]="docPageSize"
              [pageSizeOptions]="[5, 10, 20]"
              (page)="onPageChange($event)"
              aria-label="Select page"
            >
            </mat-paginator>
          </div>
        }

        @if (!documentsList || documentsList?.length === 0) {
          <div class="tw-w-full tw-border-t tw-bg-white tw-py-8 tw-text-center">
            {{ 'common.noRecord' | translate }}
          </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #chgPrice let-item="item" let-class="class">
  <div class="p-skeleton-hidden tw-flex tw-items-center" [class]="class">
    <div class="p-skeleton-bar tw-whitespace-nowrap">
      {{ item.changesValue || 0 | numberSuffix: { numberFormat: '1.2-2' } }}
    </div>
    <div
      class="p-skeleton-hidden tw-ml-2 tw-flex tw-items-center tw-rounded-full tw-px-1 tw-py-1 tw-text-xs"
      [class]="checkItemPrice(item)"
    >
      <div
        class="pitchin-icon-xs pitchin-icon-percentage tw-mr-1"
        [class]="'pitchin-icon-' + checkItemPrice(item) + '-arrow'"
      ></div>
      <div class="tw-font-medium">{{ absValue(item.priceChg || 0) | number }}%</div>
    </div>
  </div>
</ng-template>

<ng-template #status let-item="item" let-class="class" let-childClass="childClass">
  <div class="tw-flex tw-flex-wrap" [class]="class">
    @for (status of item.investorShareMarketStatus; track status) {
      <div
        class="tw-flex tw-items-center tw-rounded-full tw-px-2 tw-text-xs tw-py-1 tw-whitespace-nowrap tw-ml-2 tw-mb-1 tw-font-medium {{
          InvestorShareMarketStatusFilter[status]
        }} {{ childClass }}"
      >
        {{ InvestorShareMarketStatusFilter[status] | translate }}
      </div>
    }
  </div>
</ng-template>

<ng-template #mobileRow let-item="item">
  <div class="tw-flex tw-w-full tw-justify-between tw-pb-1 max-sm:tw-flex-wrap">
    <div class="tw-mr-auto">
      <div
        class="p-skeleton-bar !tw-block tw-font-medium tw-uppercase tw-text-black"
        [class.tw-underline]="
          item?.tickerCode &&
          ![ShareMarketStatus.Dehosting, ShareMarketStatus.Inactive].includes(item?.status)
        "
      >
        {{ item.tickerCode }}
      </div>
      <div
        class="p-skeleton-bar tw-text-sm tw-font-medium tw-text-body/50"
        [class.!tw-text-status-success]="item.status === ShareMarketStatus.Active"
        [class.!tw-text-status-fail]="item.status === ShareMarketStatus.Inactive"
      >
        {{ ShareMarketStatus[item.status] }}
      </div>
    </div>
    <div class="tw-text-right max-sm:tw-flex-[0_0_100%]">
      <ng-container
        *ngTemplateOutlet="chgPrice; context: { item: item, class: 'tw-justify-end' }"
      ></ng-container>
      <div class="p-skeleton-hidden">
        {{ 'Bid' | translate }}:
        {{ item.bestBid ? (item.bestBid | numberSuffix: { numberFormat: '1.2-2' }) : '-' }}
      </div>
      <div class="p-skeleton-hidden">
        {{ 'Ask' | translate }}:
        {{ item.bestOffer ? (item.bestOffer | numberSuffix: { numberFormat: '1.2-2' }) : '-' }}
      </div>
      <div class="p-skeleton-hidden">
        {{ 'mysec.orderQty' | translate }}: {{ item.orderQty ? (item.orderQty | number) : '-' }}
      </div>
      <div class="p-skeleton-hidden">
        {{ 'mysec.directShare' | translate }}:
        @if (item.shareHolder?.directShares !== 0) {
          <span
            >{{ item.shareHolder?.directShares | number }}
            {{
              'raise.share_plural' | translate: { 'count': item.shareHolder?.directShares }
            }}</span
          >
        } @else {
          <span class="p-skeleton-bar">-</span>
        }
        @if (item.shareHolder?.directShareHolders !== 0) {
          <span>
            ({{ item.shareHolder?.directShareHolders | number }}
            {{
              'raise.shareholder_plural'
                | translate: { 'count': item.shareHolder?.directShareHolders }
            }})</span
          >
        }
      </div>
      <div class="p-skeleton-hidden">
        {{ 'mysec.nomineeShare' | translate }}:
        @if (item.shareHolder?.nomineeShares !== 0) {
          <span
            >{{ item.shareHolder?.nomineeShares | number }}
            {{
              'raise.share_plural' | translate: { 'count': item.shareHolder?.nomineeShares }
            }}</span
          >
        } @else {
          <span class="p-skeleton-bar">-</span>
        }
        @if (item.shareHolder?.nomineeShareHolders !== 0) {
          <span>
            ({{ item.shareHolder?.nomineeShareHolders | number }}
            {{
              'raise.shareholder_plural'
                | translate: { 'count': item.shareHolder?.directShareHolders }
            }})</span
          >
        }
      </div>
    </div>
  </div>
</ng-template>
